import { extractApiError } from './errorMessages';

// A refused recap save, in words that name each refused field. The recap's
// own door answers a refusal as {message: 'Validation failed', errors: {...}}
// (offer/views.py TradeRecapViewSet create and update); extractApiError reads
// `message` first, which names nothing, so it is handed the field-keyed
// `errors`. Every screen that saves a recap words its refusal here (the recap
// form, and the Bid/Offer screen's "make a recap").
export const RECAP_FIELD_LABELS = {
  expected_delivery_start: 'Expected delivery start',
  expected_delivery_end: 'Expected delivery end',
  sale_date: 'Sale date',
  purchase_date: 'Purchase date',
  sale_contract_quantity: 'Sales quantity',
  purchase_contract_quantity: 'Purchase quantity',
  sale_contract_quantity_unit: 'Sales quantity unit',
  purchase_contract_quantity_unit: 'Purchase quantity unit',
  sale_contract_price_value: 'Sales price',
  purchase_contract_price_value: 'Purchase price',
  products: 'Products',
  sale_pledge_bank_key: 'Pledge bank',
  purchase_pledge_bank_key: 'Pledge bank',
};

// The fields a refused recap save names ({field: [problem, ...]}), so a
// screen can mark the box as well as say it. Empty for any other failure.
export const recapRefusedFields = (error) => {
  const body = error?.response?.data;
  return body && typeof body === 'object' && body.errors && typeof body.errors === 'object' ? body.errors : {};
};

export const recapSaveRefusal = (error, fallback, labels = RECAP_FIELD_LABELS) => {
  const fields = recapRefusedFields(error);
  if (!Object.keys(fields).length) return extractApiError(error, fallback);
  const labelled = Object.fromEntries(
    Object.entries(fields).map(([name, problem]) => [labels[name] || RECAP_FIELD_LABELS[name] || name, problem]),
  );
  return extractApiError({ response: { data: labelled } }, fallback);
};
